// Industry / vertical landing pages for niche SEO and direct client targeting.
// URL slugs match the legacy WordPress site so old backlinks keep working.

import { SHOWREEL } from "./content";

const findVideos = (clientKeywords) =>
  SHOWREEL.filter((s) => clientKeywords.some((k) => s.client.toLowerCase().includes(k.toLowerCase())));

export const INDUSTRIES = [
  {
    slug: "school-video-production",
    industry: "Schools",
    keyword: "school video production Liverpool",
    title: "School Video Production Liverpool | Yellow Video Production",
    description:
      "School video production in Liverpool, prospectus films, virtual open days, recruitment videos and student testimonials. Free photography included. UK-wide delivery.",
    keywords:
      "school video production liverpool, school video production, video for schools liverpool, school prospectus video liverpool, school promotional video liverpool",
    h1: "School video production in Liverpool, films that bring your prospectus to life.",
    intro:
      "Yellow's video production crew has filmed for universities, colleges and schools across the UK including LJMU and Liverpool Hope. We make school promotional videos, virtual open day tours, student testimonials and parent-recruitment films that lead to enquiries.",
    benefits: [
      "Prospectus films and virtual open-day tours",
      "Student testimonial videos that reassure parents",
      "Sensitive on-site filming with safeguarding-trained crew",
      "Multiple cut-downs for socials, web and email",
      "FREE stills photography (worth £800) included",
    ],
    relatedClients: ["LJMU", "Liverpool Hope University", "Decor"],
  },
  {
    slug: "solicitors-video-production",
    industry: "Solicitors & Law Firms",
    keyword: "video production for solicitors Liverpool",
    title: "Video Production for Solicitors Liverpool | Law Firm Videos",
    description:
      "Video production for solicitors and law firms in Liverpool. Earn trust faster with partner introduction films, client testimonials and explainer videos. Quote within 4 hours.",
    keywords:
      "video production for solicitors liverpool, law firm video production liverpool, solicitor video liverpool, legal video production liverpool",
    h1: "Video production for solicitors in Liverpool, turning trust into your unfair advantage.",
    intro:
      "Picking a solicitor is one of the most trust-driven decisions a client makes. Yellow produces introduction films, client testimonials, case-study explainers and recruitment videos for law firms across Liverpool and the UK, calm, credible and on-brand.",
    benefits: [
      "Partner & solicitor introduction films",
      "Anonymous client testimonial videos (for sensitive cases)",
      "Animated explainers for complex legal services",
      "Recruitment films for trainees and lateral hires",
      "Confidentiality-trained crew, NDAs welcome",
    ],
    relatedClients: ["Hoya Lens", "Onward Homes"],
  },
  {
    slug: "optician-video-production",
    industry: "Opticians",
    keyword: "video production for opticians Liverpool",
    title: "Video Production for Opticians Liverpool | Yellow",
    description:
      "Video production for opticians in Liverpool, clinic tour films, eye-test explainers and product showcase videos. Trusted by Hoya Lens UK. UK-wide.",
    keywords:
      "video production for opticians liverpool, optician video liverpool, eye care video production liverpool, optical video liverpool",
    h1: "Video production for opticians in Liverpool, show patients what makes you different.",
    intro:
      "Yellow has filmed for global lens manufacturer Hoya Lens and independent opticians across the UK. We produce practice-tour films, eye-test process explainers, lens-tech showcases and patient testimonials that drive bookings.",
    benefits: [
      "Practice tour films & 'meet the optometrist' intros",
      "Eye examination process explainers",
      "Lens technology showcase videos",
      "Patient testimonial films",
      "Promotional shorts for designer frames & ranges",
    ],
    relatedClients: ["Hoya Lens", "Amplifon"],
  },
  {
    slug: "video-production-for-gyms-and-personal-trainers",
    industry: "Gyms & Personal Trainers",
    keyword: "video production for gyms Liverpool",
    title: "Video Production for Gyms Liverpool | Personal Trainer Videos",
    description:
      "Video production for gyms and personal trainers in Liverpool, tour films, class showcases, transformation stories and reels for socials. Quote in 4 hours.",
    keywords:
      "video production for gyms liverpool, gym video production liverpool, personal trainer video liverpool, fitness video production liverpool",
    h1: "Video production for gyms and personal trainers in Liverpool, content that converts visitors into members.",
    intro:
      "Yellow has filmed dynamic, sweat-on-the-camera content for MADE at Moddershall Oaks and other health & wellbeing brands. We produce gym-tour films, class showcases, transformation stories and short-form social reels that drive memberships.",
    benefits: [
      "Gym tour and facility showcase films",
      "Class & PT-led training content",
      "Member transformation testimonial videos",
      "Short-form vertical reels for Instagram / TikTok",
      "Quick-turnaround monthly content packages",
    ],
    relatedClients: ["MADE", "One Wirral CIC"],
  },
  {
    slug: "education",
    industry: "Universities & Colleges",
    keyword: "education video production Liverpool",
    title: "Education Video Production Liverpool | University & College Films",
    description:
      "Education video production in Liverpool for universities, colleges and training providers. LJMU, Liverpool Hope & Decor Academy trust Yellow. UK-wide.",
    keywords:
      "education video production liverpool, university video production liverpool, college video production liverpool, training video production liverpool",
    h1: "Education video production in Liverpool, recruit students, showcase your courses, tell your story.",
    intro:
      "Yellow has produced video content for Liverpool John Moores University, Liverpool Hope University, the Decor Academy and more. We help universities and colleges tell their stories, student testimonials, course showcases, campus tours and recruitment campaigns.",
    benefits: [
      "Student testimonial films",
      "Campus tour & open-day virtual experiences",
      "Course & faculty showcase videos",
      "Recruitment & outreach campaign films",
      "Funding-bid impact reports",
    ],
    relatedClients: ["LJMU", "Liverpool Hope University", "Decor"],
  },
  {
    slug: "video-production-for-dentists",
    industry: "Dental Practices",
    keyword: "video production for dentists Liverpool",
    title: "Video Production for Dentists Liverpool | Dental Practice Films",
    description:
      "Video production for dentists in Liverpool. Practice tours, patient testimonials and treatment explainers that grow private dentistry bookings. UK-wide delivery.",
    keywords:
      "video production for dentists liverpool, dental video production liverpool, dentist video liverpool, dental practice video liverpool",
    h1: "Video production for dentists in Liverpool, fill your private treatment book with patients who already trust you.",
    intro:
      "Picking a dentist is intensely personal. Yellow produces calm, reassuring practice-tour films, patient testimonials and treatment explainers (Invisalign, implants, cosmetic) that pre-qualify private patients before they even pick up the phone.",
    benefits: [
      "Practice tour and 'meet the team' intro films",
      "Patient testimonial videos for high-ticket treatments",
      "Treatment explainer animations (Invisalign, implants, whitening)",
      "Recruitment films for dentists & nurses",
      "Compliant filming with GDC-aware crew",
    ],
    relatedClients: ["Amplifon", "Hoya Lens"],
  },
  {
    slug: "video-production-for-event-organisers",
    industry: "Event Organisers",
    keyword: "event video production Liverpool",
    title: "Event Video Production Liverpool | Conference & Highlights Films",
    description:
      "Event video production in Liverpool, conference highlights, exhibition reels, gala dinners and live-streaming. Capture the moment, sell the next ticket.",
    keywords:
      "event video production liverpool, conference video production liverpool, event highlights video liverpool, exhibition video liverpool, event videographer liverpool",
    h1: "Event video production in Liverpool, capture the moment, sell the next ticket.",
    intro:
      "Not everyone can make your event, open day, trade show or conference, so show them what they missed. Yellow's event team has filmed gala dinners, conferences, exhibitions and product launches across the UK, delivering same-week highlight reels that sell next year's tickets.",
    benefits: [
      "Conference highlight & sizzle reels (same-week turnaround)",
      "Multi-camera live event capture",
      "Speaker interview & breakout-session films",
      "Attendee vox-pop testimonials",
      "Optional live-streaming with branded overlays",
    ],
    relatedClients: ["Community Foundation", "Aldi"],
  },
  {
    slug: "video-production-for-training-companies",
    industry: "Training Companies",
    keyword: "training video production Liverpool",
    title: "Training Video Production Liverpool | L&D & Course Films",
    description:
      "Training video production in Liverpool for L&D providers, course creators and corporate trainers. Engaging modular films that learners finish.",
    keywords:
      "training video production liverpool, e-learning video production liverpool, course video production liverpool, l&d video liverpool",
    h1: "Training video production in Liverpool, courses learners finish.",
    intro:
      "Yellow has produced training films for global brands and L&D companies including Bob's Business cyber-security and Oven Pride. We script, film, edit, animate and sound-design training content that's bingeable rather than a tick-box exercise.",
    benefits: [
      "Modular course videos (LMS-ready exports)",
      "Animated explainers for tricky topics",
      "Scenario-based training films with actors",
      "VO + branded motion graphics",
      "SCORM / xAPI delivery on request",
    ],
    relatedClients: ["Bob's Business", "Oven Pride"],
  },
  {
    slug: "manufacturing-video-production",
    industry: "Manufacturing & Industrial",
    keyword: "manufacturing video production Liverpool",
    title: "Manufacturing Video Production Liverpool | Factory Films",
    description:
      "Manufacturing video production in Liverpool, factory tours, process films, product showcases and capability reels for industrial brands. UK-wide.",
    keywords:
      "manufacturing video production liverpool, industrial video production liverpool, factory video liverpool, product video production liverpool, b2b video production liverpool",
    h1: "Manufacturing video production in Liverpool, factory films that win contracts.",
    intro:
      "Yellow has filmed inside factories, warehouses and labs across the UK, including for Shelfspan, T3DMC and Aldi. We turn complex industrial processes into cinematic capability reels that B2B buyers watch all the way through.",
    benefits: [
      "Factory & plant tour films",
      "Process and capability explainers",
      "Product-in-action showcase videos",
      "Drone + interior multi-camera coverage",
      "Time-lapse build films for major contracts",
    ],
    relatedClients: ["T3DMC", "Shelfspan", "Aldi"],
  },
  {
    slug: "insurance-video-production",
    industry: "Insurance & Financial Services",
    keyword: "insurance video production Liverpool",
    title: "Insurance Video Production Liverpool | Financial Services Films",
    description:
      "Video production for insurers and financial services firms in Liverpool, brand films, policyholder explainers, recruitment films & claims explainers. UK-wide.",
    keywords:
      "insurance video production liverpool, financial services video production liverpool, insurance video liverpool, fintech video liverpool",
    h1: "Insurance & financial services video production in Liverpool, make the complicated feel simple.",
    intro:
      "Insurance and financial services live and die by trust. Yellow produces brand films, policyholder explainers, recruitment videos and claims-process explainers that strip away the jargon, for insurers, brokers, IFAs and fintech challengers.",
    benefits: [
      "Brand & 'why us' films",
      "Animated policy & product explainers",
      "Claims process walk-throughs",
      "Recruitment films for graduates & lateral hires",
      "Compliance-aware scripting & legal sign-off built in",
    ],
    relatedClients: ["Bob's Business", "Hoya Lens"],
  },
  {
    slug: "video-production-for-housing-associations",
    industry: "Housing Associations",
    keyword: "video production for housing associations Liverpool",
    title: "Video Production for Housing Associations Liverpool | Yellow",
    description:
      "Video production for housing associations in Liverpool. Resident stories, regeneration films, recruitment & service explainers. Onward Homes & more.",
    keywords:
      "video production for housing associations liverpool, housing association video production liverpool, social housing video liverpool, resident video liverpool",
    h1: "Video production for housing associations in Liverpool, resident-led stories that build community.",
    intro:
      "Yellow produces video content for Onward Homes and other housing providers across the North West. We film resident-led stories, regeneration progress films, service explainers and recruitment campaigns that earn trust with both residents and regulators.",
    benefits: [
      "Resident & tenant testimonial films",
      "Regeneration & build-progress drone reels",
      "Service explainer videos (repairs, lettings, ASB)",
      "Recruitment films for housing officers & maintenance",
      "Sensitive on-estate filming with safeguarding crew",
    ],
    relatedClients: ["Onward Homes", "DeTrafford", "Community Foundation"],
  },
  {
    slug: "property-video-production",
    industry: "Property & Estate Agency",
    keyword: "property video production Liverpool",
    title: "Property Video Production Liverpool | Estate Agent Films",
    description:
      "Property video production in Liverpool, listing films, developer progress reels, drone aerials and walk-throughs that sell. Trusted by DeTrafford.",
    keywords:
      "property video production liverpool, estate agent video liverpool, property listing video liverpool, developer video production liverpool, property drone video liverpool",
    h1: "Property video production in Liverpool, listings that move, developments that pre-sell.",
    intro:
      "Yellow has filmed for leading developer DeTrafford and estate agents across Liverpool and the North West. Listing walk-throughs, drone aerials, build-progress reels and brand films for developers chasing investor confidence.",
    benefits: [
      "Listing films with cinematic walk-through",
      "CAA-licensed drone aerials & site overviews",
      "Quarterly build-progress reels for investors",
      "Developer brand & sales-suite films",
      "Same-week turnaround for time-sensitive listings",
    ],
    relatedClients: ["DeTrafford", "Onward Homes"],
  },
  {
    slug: "video-for-agencies",
    industry: "Marketing Agencies",
    keyword: "video production for agencies Liverpool",
    title: "Video Production for Agencies Liverpool | White Label Partner",
    description:
      "Video production for marketing agencies in Liverpool, white-label filming, editing, animation & drone delivered under your brand. NDA-friendly.",
    keywords:
      "video production for agencies liverpool, white label video production liverpool, agency video production partner, freelance video production liverpool",
    h1: "Video production for marketing agencies in Liverpool, your invisible production team.",
    intro:
      "Need extra capacity, missing in-house skills, or want to win a brief that needs production firepower? Yellow becomes your white-label video production partner, under your brand, with NDAs as standard.",
    benefits: [
      "White-label filming, editing & motion graphics",
      "Drone, photography and animation under your brand",
      "NDAs signed before specifics are discussed",
      "Fast turnaround for time-pressed pitches & deliverables",
      "Multiple revisions and unlimited copyright usage",
    ],
    relatedClients: ["Bob's Business", "Persil", "Aldi", "Dreamland"],
  },
  {
    slug: "mvp-micro-video-production",
    industry: "Micro Video Production (MVP)",
    keyword: "micro video production Liverpool",
    title: "Micro Video Production (MVP) Liverpool | Short-Form Content",
    description:
      "Micro video production in Liverpool, short-form social content, vertical reels and content drops at scale. Quick turnaround, fixed prices, UK-wide.",
    keywords:
      "micro video production liverpool, short form video liverpool, social video production liverpool, content drop video production liverpool, vertical video liverpool",
    h1: "Micro video production (MVP) in Liverpool, content drops at scale, without the big-budget price tag.",
    intro:
      "Need an ongoing supply of short-form social content for Instagram, TikTok, LinkedIn or YouTube Shorts? Yellow's MVP service ships multiple bite-sized videos per shoot day, quick, on-brand and built for socials.",
    benefits: [
      "8–12 short-form videos per shoot day",
      "Vertical & square aspect-ratio cut-downs",
      "Captions, brand graphics & music included",
      "Monthly content-drop packages",
      "Fixed pricing, no surprise invoices",
    ],
    relatedClients: ["Aldi", "Dreamland", "Persil"],
  },
  {
    slug: "client-testimonial-videos",
    industry: "Client Testimonial Videos",
    keyword: "client testimonial videos Liverpool",
    title: "Client Testimonial Videos Liverpool | Yellow Video Production",
    description:
      "Client testimonial video production in Liverpool. Authentic customer story films that pre-qualify buyers and outsell every other marketing asset.",
    keywords:
      "client testimonial videos liverpool, customer testimonial video liverpool, case study video production liverpool, testimonial filmmaker liverpool",
    h1: "Client testimonial videos in Liverpool, your happiest customers selling for you.",
    intro:
      "The world is sceptical of marketing, potential customers won't believe how good you are without a 2nd opinion. Yellow produces honest, on-brand client testimonial videos that pre-qualify buyers before your sales team even picks up the phone.",
    benefits: [
      "Pre-call client briefing & question coaching",
      "Sensitive interviewer (no awkward rabbit-in-headlights footage)",
      "B-roll capture so the video doesn't feel static",
      "Short-form vertical edits for socials & cold outreach",
      "Free stills photography of the client too",
    ],
    relatedClients: ["Amplifon", "Hoya Lens", "Onward Homes"],
  },
];

export function getIndustry(slug) {
  return INDUSTRIES.find((i) => i.slug === slug);
}

// Pick the related showreel videos for a given industry
export function relatedVideosFor(industry) {
  return findVideos(industry.relatedClients).slice(0, 4);
}
